'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface CompanyIntroductionProps {
  title: string;
  titleEn: string;
  description: string;
  descriptionEn: string;
  mission: string;
  missionEn: string;
  vision: string;
  visionEn: string;
}

const CompanyIntroduction = ({
  title,
  titleEn,
  description,
  descriptionEn,
  mission,
  missionEn,
  vision,
  visionEn,
}: CompanyIntroductionProps) => {
  const { t } = useLanguage();

  return (
    <section className="bg-card rounded-lg shadow-sm border border-border p-8 md:p-12">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-amiri">
            {t(title, titleEn)}
          </h1>
          <p className="text-lg md:text-xl text-foreground leading-relaxed">
            {t(description, descriptionEn)}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-12">
          <div className="bg-gradient-to-br from-primary to-secondary rounded-lg p-8 text-white">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <Icon name="LightBulbIcon" size={24} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold font-amiri">{t('رؤيتنا', 'Our Vision')}</h2>
            </div>
            <p className="text-white/90 leading-relaxed text-lg">{t(vision, visionEn)}</p>
          </div>

          <div className="bg-gradient-to-br from-accent to-warning rounded-lg p-8 text-white">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <Icon name="RocketLaunchIcon" size={24} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold font-amiri">{t('مهمتنا', 'Our Mission')}</h2>
            </div>
            <p className="text-white/90 leading-relaxed text-lg">{t(mission, missionEn)}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyIntroduction;